import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GenerateLocationDescription } from 'domain/usecases/ai/generate-location-description';
import { RemoteGenerateLocationDescription } from 'data/usecases/ai/remote-generate-location-description';

export const makeGenerateLocationDescription = (locationId: string): GenerateLocationDescription => {
  return new RemoteGenerateLocationDescription(
    makeApiUrl(`/location/${locationId}/description/generate`),
    makeAuthorizeHttpClientDecorator()
  );
};
